<template>
    <div class="app-body">
        <div class="a-flex-rsbc a-ptb-6">
            <span class="a-fs-16 a-fw-700">预充余额管理</span>
        </div>
        <el-card class="el-main">
            <le-search-form @reset="handlerRest" @search="handlerSearch" id="leSearch">
                <le-select-remote-search label="电费项目" v-model="pageParam.params.projectId" :options="optionsElectric" placeholder="请选择电费项目(可搜索)" />
                <le-select-remote-search label="电表号" v-model="pageParam.params.ammeterId" :options="optionsAmmeter" placeholder="请选择电表(可搜索)" />
                <le-select-remote-search label="站点" v-model="pageParam.params.stationId" :options="optionsStation" placeholder="请选择站点(可搜索)" />
            </le-search-form>
            <le-pagview ref="prepayPage" @setData="setTableData" :pageParam="pageParam" :isFixed="true" :tableRef="$refs.prepayList" :pageSizeDefault='10'>
                <el-table ref="prepayList" :data="tableData" :highlight-current-row="true" v-sticky="{ top: 0, parent:'.el-card__body' }" style="width: 100%">
                    <el-table-column prop="province" label="电表号" min-width="140">
                        <template slot-scope="{ row }">
                            <span>{{ row.ammeterNumber || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="stationName" label="电费项目" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.projectName || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="companyName" label="站点" min-width="120">
                        <template slot-scope="{ row }">
                            <el-popover
                                placement="top-start"
                                title="站点"
                                width="400"
                                trigger="hover">
                                <div class="a-flex-cfsfs">
                                    <span class="a-fs-13 a-mt-10" v-for="(item,index) in row.stationInfoList" :key="index">{{ index+1 }}. {{ item.name }}</span>
                                </div>
                                <div slot="reference" class="textOver1" style="width: 140px;display: block !important">{{ row.stationInfoText || '-' }}</div>
                            </el-popover>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="当前电费结余" min-width="120">
                        <template slot-scope="{ row }">
                            <span>￥{{ util.numFormat(row.remainMoney) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="日均估算电费" min-width="120">
                        <template slot="header" slot-scope="scope">
                            <div class="a-flex-rfsc">
                                <span>日均估算电费</span>
                                <el-tooltip class="item" effect="dark" content="日均估算电费取该电费项目最近一次账单的日均电费（区间电费/区间天数）" placement="top">
                                    <span class="el-icon-question"></span>
                                </el-tooltip>
                            </div>
                        </template>
                        <template slot-scope="{ row }">
                            <span>￥{{ util.numFormat(row.perDayPrice) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="deviceType" label="预计可用天数(天)" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.canUseDay || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="deviceType" label="上次充值日期" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.lastBillDate || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="deviceType" label="上次充值金额" min-width="120">
                        <template slot-scope="{ row }">
                            <span>￥{{ util.numFormat(row.lastBillRecharge) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="deviceType" label="预警方式" min-width="120" v-if="company.id == 2">
                        <template slot-scope="{ row }">
                            <span>{{ row.alertType | initDic(alertTypeDic) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="deviceType" label="预警阈值" min-width="120" v-if="company.id == 2">
                        <template slot-scope="{ row }">
                            <span v-if="row.alertType == 1">￥{{ util.numFormat(row.alertValue) }}</span>
                            <span v-else-if="row.alertType == 2">{{ row.alertValue }}天</span>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="pid" label="操作" width="100" fixed="right" v-if="company.id == 2">
                        <template slot-scope="{ row }">
                            <el-button type="text" @click="handleSetWarning(row)">预警设置</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </le-pagview>
        </el-card>
        <electric-warning-edit ref="warningEdit" @change="handleSetSuccess"></electric-warning-edit>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import util from '../../../src/utils/util'
    import ElectricWarningEdit from './child/electric-warning-edit.vue'
    export default {
        components: {
            ElectricWarningEdit
        },
        data () {
            return {
                util: util,
                tableData: [],
                pageParam: {
                    url: this.$Config.apiUrl.electricPreChargePage,
                    method: "post",
                    params: {
                        "ammeterNumber": "",
                        "ammeterId": "",
                        "companyId": "",
                        "projectName": "",
                        "projectId": "",
                        "stationId": ""
                    },
                    freshCtrl: 1,
                },
                optionsStation: {
                    url: this.$Config.apiUrl.getStationList,
                    method: "post",
                    params: {},
                    showLoading: false,
                    labelKey: "name",
                    valueKey: "stationId",
                    searchKey: "name",
                    pageSize: 100
                },//站点数据
                optionsElectric: {
                    url: this.$Config.apiUrl.electricFilter,
                    method: "post",
                    params: {},
                    showLoading: false,
                    labelKey: "name",
                    valueKey: "id",
                    searchKey: "name",
                    pageSize: 100
                },
                optionsAmmeter: {
                    url: this.$Config.apiUrl.ammeterFilter,
                    method: "post",
                    params: {},
                    showLoading: false,
                    labelKey: "name",
                    valueKey: "id",
                    searchKey: "name",
                    pageSize: 100
                },
                alertTypeDic: [
                    {
                        label: '余额',
                        value: 1
                    },
                    {
                        label: '可用天数',
                        value: 2
                    }
                ]
            }
        },
        computed: {
            ...mapState({
                company: state => state.company.company
            })
        },
        created () {
            this.$getDic('timeCycle','select').then(res=>{ this.timeCycleDic = res; })
            this.$getDic('billType','select').then(res=>{ this.billTypeDic = res; })
        },
        activated () {
            this.pageParam.freshCtrl++;
        },
        methods:{
            //获取列表
            setTableData(data) {
                this.tableData = data.map(item=>{
                    let stationInfoText= ''
                    if(item.stationInfoList && item.stationInfoList.length) {
                        stationInfoText = item.stationInfoList.map(ite=>{
                            return ite.name
                        }).join('，')
                    }
                    return {
                        ...item,
                        stationInfoText: stationInfoText
                    }
                })
            },
            handlerRest() {
                this.pageParam.params = {
                    "ammeterNumber": "",
                    "ammeterId": "",
                    "companyId": "",
                    "projectName": "",
                    "projectId": "",
                    "stationId": ""
                };
                this.handlerSearch()
            },
            handlerSearch() {
                this.$refs['prepayPage'].pageNum = 1
                this.pageParam.freshCtrl++;
            },
            handleSetWarning (datas) {
                this.$refs['warningEdit'].id = datas.id
                this.$refs['warningEdit'].form = {
                    "alertType": datas.alertType,
                    "alertValue": datas.alertType ? (datas.alertValue / 100).toFixed(2) : datas.alertValue,
                }
                this.$refs['warningEdit'].dialogVisible = true
            },
            handleSetSuccess () {
                this.pageParam.freshCtrl++;
            },
            exportfile () {
                // this.$exfile({
                //     code: 15,
                //     fileName: this.pageParam.params.searchStartTime + ' 至 ' + this.pageParam.params.searchEndTime + ' 省份经营分析',
                //     startTime: this.pageParam.params.searchStartTime,
                //     endTime: this.pageParam.params.searchEndTime,
                //     params: this.pageParam.params
                // })
            }
        }
    }
</script>

<style lang="scss" scoped>
.s-btn-add{
    width: 105px;
}
/deep/ .s-search-label{
    width: 100px
}
/deep/ .el-table__body-wrapper::-webkit-scrollbar {
    /*width: 0;宽度为0隐藏*/
    width: 0 !important;
    height: 0 !important;
}
/deep/ .el-table__fixed, /deep/ .el-table__fixed-right{
    height: 100% !important;
}
</style>